export default "__VITE_ASSET__af36d9b2__"